import React from 'react';
import styles from '../../styles/components/answers/DropdownMenu.module.css';
import UUID from '@ax2/common/model/UUID';
import {
  ParticipantDefinedField,
  ParticipantDefinedFieldData,
} from './ParticipantDefinedOption';
import Dropdown from '@ax2/common/components/Dropdown';
import _ from 'lodash';

export interface DropdownMenuOption {
  id: UUID;
  title: string;
}
export type DropdownMenuParticipantDefinedOption = ParticipantDefinedFieldData;

export interface DropdownMenuData {
  options: (DropdownMenuOption | DropdownMenuParticipantDefinedOption)[];
  preselected?: UUID;
  //isClearable?: boolean;
  onCompletion: (id: UUID | null) => void;
  key?: string;
}

function getOptionText(
  opt: DropdownMenuOption | DropdownMenuParticipantDefinedOption
) {
  return 'title' in opt ? opt.title : 'Other';
}
/*function getClearSelection(onCompletion: () => void) {
  return (
    <div className={styles.optionWrapper} onClick={onCompletion}>
      <span className={styles.optionText}></span>
    </div>
  );
}*/

export const DropdownMenu: React.FC<DropdownMenuData> = data => {
  const selected = _.find(data.options, o => o.id === data.preselected);
  const options = data.options.map(option => ({
    title: getOptionText(option),
    value: option.id,
  }));
  return (
    <div className={styles.dropdownWrapper}>
      <Dropdown
        value={data.preselected}
        options={options}
        onChange={data.onCompletion}
      />
      {selected && 'value' in selected && (
        <div className={styles.participantDefOptContainer}>
          <ParticipantDefinedField {...selected} />
        </div>
      )}
    </div>
  );
};
